import { render, staticRenderFns } from "./JobAddPopup.vue?vue&type=template&id=4b94368e"
import script from "./JobAddPopup.vue?vue&type=script&lang=js"
export * from "./JobAddPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports